import React, { useCallback, useEffect, useRef } from "react";
import { initRequest } from "../../shared/common/learnosityAuthorInit";
import { getRequest } from "../../../api/user.service";

export default function LearnosityPassageEditor(props: any) {
  let authorApp;
  const isMounted = useRef(true);

  const initialization = useCallback(() => {
    if (isMounted.current && document.getElementById("learnosity-author")) {
      const callbacks = {
        readyListener: function () {
          authorApp.on("render:item", function () {
            props.authorAppParent(authorApp);
            const features = authorApp.getItem().features;
            if (features.length == 0) {
              const passageData =
                props.widgetPsgDataEN === null ||
                props.widgetPsgDataEN === "" ||
                props.widgetPsgDataEN === undefined
                  ? {
                      type: "sharedpassage",
                      content: "",
                    }
                  : props.widgetPsgDataEN;
              authorApp.setWidget(passageData, "Passage");
              props.setWidgetPsgEN(passageData);
            } else {
              const itemRef = authorApp.getItem().item.reference;
              const widgetRef = features[features.length - 1].reference;
              if (!props.widgetPsgDataEN) {
                props.setLoading(false);
                return authorApp.navigate(
                  "items/" + itemRef + "/widgets/" + widgetRef + ""
                );
              } else {
                authorApp.setWidget(props.widgetPsgDataEN, "Passage");
              }
            }
            props.setLoading(false);
          });
          authorApp.on("widgetedit:preview:changed", function () {
            props.setWidgetPsgEN(authorApp.getWidget());
          });
          authorApp.on("widgetedit:widget:ready", function () {
            props.setIsLrnEditorLoaded(true);
            if (authorApp.getWidget()["paginated_content"]) {
              props.setIsLrnPaginated(true);
            }
          });
        },
      };

      props.setLoading(true);
      const request = initRequest(props.englishPsgReferenceId, "features");
      getRequest("author", JSON.stringify(request)).then((response) => {
        if (response.data) {
          authorApp = window["LearnosityAuthor"]?.init(
            response.data,
            callbacks
          );
        }
      });
    }
  }, []);

  useEffect(() => {
    initialization();

    // Clean-up function
    return () => {
      isMounted.current = false;
    };
  }, []);

  return (
    <div className="main-content">
      <div id="learnosity-author"></div>
    </div>
  );
}
